/* ==========================================================================
   JYG · Selector de variantes EZ-RIG
   --------------------------------------------------------------------------
   MODELO EN CASCADA. La primera opción manda y siempre se puede elegir; cada
   opción siguiente se limita por lo elegido en las anteriores, nunca al revés.
   Para un producto con STYLE / COLOR / PESO-COLA eso significa:

     · STYLE  se elige libremente, siempre.
     · COLOR  muestra solo lo que existe para ese estilo.
     · PESO   muestra solo lo que existe para ese estilo y ese color; si el
              cuerpo elegido es una cola, la única salida es «cola», así que el
              grupo se pliega y se selecciona solo.

   Al cambiar una opción, las posteriores se recolocan a la combinación válida
   más parecida a lo que ya había elegido el cliente. Las anteriores no se tocan
   jamás: lo que el cliente acaba de decidir se respeta.

   NO toca precio, galería ni botón de compra: de eso sigue encargándose
   theme.js de Impulse, al que avisamos con eventos `change` nativos.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__jygPickerReady) return;

    var dataEl = root.querySelector('[data-jyg-variants]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      return; // JSON mal formado: se queda el selector tal cual, sin romper la ficha
    }

    var variants = (data && data.variants) || [];
    if (!variants.length) return;

    var wrappers = Array.prototype.slice.call(root.querySelectorAll('[data-jyg-option]'));
    if (!wrappers.length) return;

    var collapseSingle = root.getAttribute('data-jyg-collapse-single') === 'true';

    root.__jygPickerReady = true;
    var busy = false;

    function currentSelection() {
      return wrappers.map(function (w) {
        var checked = w.querySelector('input[data-variant-input]:checked');
        return checked ? checked.value : null;
      });
    }

    /* ¿Respeta esta variante todo lo elegido en las opciones ANTERIORES a idx? */
    function matchesPrefix(variant, selection, idx) {
      for (var j = 0; j < idx; j++) {
        if (selection[j] === null) continue;
        if (variant.o[j] !== selection[j]) return false;
      }
      return true;
    }

    function comboExists(selection) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < selection.length; j++) {
          if (selection[j] !== null && variants[i].o[j] !== selection[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function setValue(wrapper, value) {
      var inputs = wrapper.querySelectorAll('input[data-variant-input]');
      Array.prototype.forEach.call(inputs, function (input) {
        if (input.value === value && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* Recoloca SOLO las opciones posteriores a changedIdx, buscando la
       combinación que más se parezca a lo que ya estaba elegido. */
    function reconcile(changedIdx) {
      var selection = currentSelection();
      var best = null;
      var bestScore = -1;
      var i, j, variant, score, ok;

      for (i = 0; i < variants.length; i++) {
        variant = variants[i];
        ok = true;
        for (j = 0; j <= changedIdx; j++) {
          if (selection[j] !== null && variant.o[j] !== selection[j]) { ok = false; break; }
        }
        if (!ok) continue;

        score = 0;
        for (j = changedIdx + 1; j < selection.length; j++) {
          if (selection[j] !== null && variant.o[j] === selection[j]) score += 2;
        }
        if (variant.a) score += 1;
        if (score > bestScore) { bestScore = score; best = variant; }
      }

      /* Red de seguridad: si ni siquiera respetando el prefijo hay salida,
         nos quedamos con cualquier variante que tenga ese valor y recolocamos
         todo lo demás. Mejor mover de más que dejar al cliente atascado. */
      if (!best) {
        for (i = 0; i < variants.length; i++) {
          variant = variants[i];
          if (selection[changedIdx] !== null && variant.o[changedIdx] !== selection[changedIdx]) continue;
          if (!best) best = variant;
          if (variant.a) { best = variant; break; }
        }
        if (!best) return;
        busy = true;
        wrappers.forEach(function (w, k) {
          if (k === changedIdx) return;
          setValue(w, best.o[k]);
        });
        busy = false;
        return;
      }

      busy = true;
      wrappers.forEach(function (w, k) {
        if (k <= changedIdx) return;
        setValue(w, best.o[k]);
      });
      busy = false;
    }

    function refresh() {
      var selection = currentSelection();

      wrappers.forEach(function (wrapper, optIdx) {
        var items = wrapper.querySelectorAll('.variant-input');
        var possible = [];

        Array.prototype.forEach.call(items, function (item) {
          var value = item.getAttribute('data-value');
          var exists = false;
          var inStock = false;
          var image = null;
          var fallbackImage = null;

          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            if (variant.o[optIdx] !== value) continue;

            if (!fallbackImage && variant.m) fallbackImage = variant.m;
            if (!matchesPrefix(variant, selection, optIdx)) continue;

            exists = true;
            if (!image && variant.m) image = variant.m;
            if (variant.a) {
              inStock = true;
              if (variant.m) image = variant.m;
              break;
            }
          }

          if (exists) possible.push(value);
          if (!image) image = fallbackImage;

          item.classList.toggle('jyg-is-unavailable', !exists);
          item.classList.toggle('jyg-is-soldout', exists && !inStock);

          /* data-jyg-locked = foto puesta a mano (editor, archivo o swatch
             nativo de Shopify). Manda siempre: no la pisamos. */
          var img = item.querySelector('[data-jyg-swatch-img]');
          if (img && image && !img.hasAttribute('data-jyg-locked')) {
            if (img.getAttribute('src') !== image) img.setAttribute('src', image);
          }
        });

        // Una sola salida posible: se pliega y se da por elegida
        var collapse = collapseSingle && possible.length === 1 && items.length > 1;
        wrapper.classList.toggle('jyg-option-collapsed', collapse);
        if (collapse && selection[optIdx] !== possible[0]) {
          busy = true;
          setValue(wrapper, possible[0]);
          busy = false;
          selection[optIdx] = possible[0];
        }

        var label = root.querySelector('[data-jyg-selected-label="' + optIdx + '"]');
        if (label && selection[optIdx]) label.textContent = selection[optIdx];
      });
    }

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.hasAttribute || !target.hasAttribute('data-variant-input')) return;
      if (busy) return;

      var wrapper = target.closest('[data-jyg-option]');
      if (!wrapper) return;

      var optIdx = wrappers.indexOf(wrapper);
      if (optIdx < 0) return;

      /* Comprobamos la combinación ENTERA, no solo el botón pulsado: es lo que
         hace que al volver de «cabeza + 1/2 oz» a un cuerpo, el peso se corrija
         solo a «cola» en vez de quedarse en un estado imposible. */
      if (!comboExists(currentSelection())) {
        reconcile(optIdx);
      }

      refresh();
    });

    if (!comboExists(currentSelection())) reconcile(0);
    refresh();
  }

  function initAll(scope) {
    var context = scope || document;
    var sections = context.querySelectorAll('.jyg-pdp');
    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // El editor de temas recarga secciones sueltas sin recargar la página
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();


/* ==========================================================================
   JYG · Bloque «Cómo se monta»
   --------------------------------------------------------------------------
   Tres cosas:
     1. Abrir y cerrar el panel. El estado inicial lo pone el CSS según la
        pantalla; al pulsar se fija a mano con is-open / is-closed, que mandan
        sobre lo anterior, para que el cliente pueda cerrar lo que abrió.
     2. Pintar en el diagrama las fotos REALES de la variante: el cuerpo y la
        cabeza del color que hay elegido. Se buscan en la misma tabla de
        variantes que usa el selector, puntuando por cuántas opciones coinciden
        con lo elegido — así sale el color correcto sin tener que saber cuál de
        las tres opciones es el color. Si en ese color no existe la pieza, se
        deja la foto de respaldo del bloque.
     3. Cambiar el texto de compatibilidad según se mire un cuerpo o una cabeza.
   ========================================================================== */
(function () {
  'use strict';

  function norm(s) {
    return (s || '').toString().toLowerCase().replace(/[\s\-_]/g, '');
  }

  function datos(root) {
    if (root.__jygData !== undefined) return root.__jygData;
    var el = root.querySelector('[data-jyg-variants]');
    var d = null;
    if (el) {
      try { d = JSON.parse(el.textContent); } catch (err) { d = null; }
    }
    root.__jygData = d;
    return d;
  }

  function seleccion(root) {
    return Array.prototype.map.call(
      root.querySelectorAll('.jyg-variant-wrapper'),
      function (w) {
        var c = w.querySelector('input[data-variant-input]:checked');
        return c ? c.value : null;
      }
    );
  }

  function esCabeza(valor, lista) {
    return lista.indexOf(norm(valor)) > -1;
  }

  /* Cuantos colores hay DE VERDAD para el lado que se esta mirando.
     El numero se escribia a mano en el texto y estaba mal: decia 14 cuando en
     los cuerpos hay 11. Y aunque se corrigiera, cada color nuevo lo volveria a
     dejar mentiroso. Se cuenta de la misma tabla de variantes que usa todo lo
     demas, asi que no hay nada que mantener. Los cuerpos y las cabezas pueden
     tener cuentas distintas, por eso se cuenta por separado. */
  function cuantosColores(root, lista, lado, idx) {
    var d = datos(root);
    if (!d || !d.variants) return 0;
    var vistos = {};
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      var cab = esCabeza(v.o[0], lista);
      if ((lado === 'head') !== cab) continue;
      var val = v.o[idx];
      if (val) vistos[norm(val)] = 1;
    }
    return Object.keys(vistos).length;
  }

  /* La foto de la pieza pedida, en el color que el cliente tiene elegido.
     Se puntúa cada variante por cuántas de las OTRAS opciones coinciden, así
     que el color gana y el peso desempata.

     Ojo con el detalle que se me escapó la primera vez: todos los cuerpos de un
     mismo color puntúan igual, así que salía siempre el primero de la lista y
     el Y-TAIL no aparecía nunca. Por eso `exacto` manda: si el cliente está
     mirando un cuerpo, la caja del cuerpo tiene que ser ESE cuerpo. Y cuando se
     pasa a una cabeza, se recuerda el último cuerpo que estuvo mirando en vez
     de volver al primero. */
  function fotoDe(root, lista, quiero, exacto) {
    var d = datos(root);
    if (!d || !d.variants) return null;
    var sel = seleccion(root);
    var mejor = null;
    var mejorPunt = -1;

    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      if (!v.m) continue;
      var esta = esCabeza(v.o[0], lista) ? 'head' : 'body';
      if (esta !== quiero) continue;
      if (exacto && norm(v.o[0]) !== norm(exacto)) continue;

      var punt = 0;
      for (var j = 1; j < sel.length; j++) {
        if (sel[j] !== null && v.o[j] === sel[j]) punt += 2;
      }
      if (v.a) punt += 1;
      if (punt > mejorPunt) { mejorPunt = punt; mejor = v; }
    }
    return mejor ? mejor.m : null;
  }

  function abierto(block) {
    var panel = block.querySelector('.jyg-howto__panel');
    return !!panel && getComputedStyle(panel).display !== 'none';
  }

  function ligarBoton(block) {
    var btn = block.querySelector('[data-jyg-howto-toggle]');
    if (!btn || btn.__jygBound) return;
    btn.__jygBound = true;
    btn.setAttribute('aria-expanded', abierto(block) ? 'true' : 'false');
    btn.addEventListener('click', function () {
      var ya = abierto(block);
      block.classList.toggle('is-open', !ya);
      block.classList.toggle('is-closed', ya);
      btn.setAttribute('aria-expanded', ya ? 'false' : 'true');
    });
  }

  function pintar(root, block) {
    var lista = (block.getAttribute('data-jyg-head-values') || 'JIG HEAD').split(',').map(norm);
    var sel = seleccion(root);
    var lado = sel.length && sel[0] !== null && esCabeza(sel[0], lista) ? 'head' : 'body';

    /* Memoria del último cuerpo y de la última cabeza que se han mirado, para
       que la caja que no está seleccionada no se quede en el primer valor de
       la lista sino en lo que el cliente venía viendo. */
    if (sel[0]) {
      if (lado === 'body') root.__jygUltCuerpo = sel[0];
      else root.__jygUltCabeza = sel[0];
    }

    Array.prototype.forEach.call(block.querySelectorAll('[data-jyg-fits]'), function (g) {
      if (g.getAttribute('data-jyg-fits') === lado) g.removeAttribute('hidden');
      else g.setAttribute('hidden', '');
    });

    /* La coletilla puede llevar {n}: se cambia por la cuenta real de colores.
       Se guarda la plantilla la primera vez, porque despues del primer cambio
       el texto ya no tendria el {n}. */
    var idxColor = parseInt(block.getAttribute('data-jyg-color-opt') || '2', 10) - 1;
    Array.prototype.forEach.call(block.querySelectorAll('[data-jyg-fits]'), function (g) {
      var tip = g.querySelector('.jyg-howto__tip');
      if (!tip) return;
      if (tip.__tpl === undefined) tip.__tpl = tip.innerHTML;
      if (tip.__tpl.indexOf('{n}') === -1) return;
      var n = cuantosColores(root, lista, g.getAttribute('data-jyg-fits'), idxColor);
      tip.innerHTML = tip.__tpl.replace(/\{n\}/g, n);
    });

    Array.prototype.forEach.call(block.querySelectorAll('[data-jyg-piece]'), function (p) {
      var quien = p.getAttribute('data-jyg-piece');
      p.classList.toggle('is-dim', quien !== lado);

      var img = p.querySelector('[data-jyg-piece-img]');
      if (!img) return;

      var exacto = null;
      if (quien === lado) exacto = sel[0];
      else if (quien === 'body') exacto = root.__jygUltCuerpo || null;
      else exacto = root.__jygUltCabeza || null;

      var url = fotoDe(root, lista, quien, exacto)
             || fotoDe(root, lista, quien, null)
             || img.getAttribute('data-jyg-fallback') || '';
      if (url && img.getAttribute('src') !== url) img.setAttribute('src', url);
      p.classList.toggle('is-empty', !url);
    });
  }

  function init(root) {
    var bloques = root.querySelectorAll('[data-jyg-howto]');
    if (!bloques.length) return;

    Array.prototype.forEach.call(bloques, function (block) {
      ligarBoton(block);
      pintar(root, block);
    });

    if (root.__jygHowtoWired) return;
    root.__jygHowtoWired = true;

    root.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || !t.hasAttribute || !t.hasAttribute('data-variant-input')) return;
      Array.prototype.forEach.call(root.querySelectorAll('[data-jyg-howto]'), function (block) {
        pintar(root, block);
      });
    });
  }

  function initAll(scope) {
    var ctx = scope || document;
    Array.prototype.forEach.call(ctx.querySelectorAll('.jyg-pdp'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();


/* ==========================================================================
   JYG · Barra de compra fija
   --------------------------------------------------------------------------
   Aparece cuando el botón de compra de verdad sale de pantalla. No duplica el
   formulario: su botón lleva el atributo `form`, así que envía el mismo que la
   ficha. Aquí solo se ocupa de mostrarse, de reflejar precio y selección, y de
   subir al selector cuando se pulsa el resumen.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    var barra = root.querySelector('[data-jyg-sticky]');
    if (!barra || barra.__jygReady) return;

    var ancla = root.querySelector('.product-block .add-to-cart, .product-block [name="add"], form [name="add"]');
    if (!ancla) return;
    barra.__jygReady = true;

    var resumen = barra.querySelector('[data-jyg-sticky-summary]');
    var precioEl = barra.querySelector('[data-jyg-sticky-price]');
    var foto = barra.querySelector('[data-jyg-sticky-img]');
    var saltar = barra.querySelector('[data-jyg-sticky-jump]');
    var precioReal = root.querySelector('[data-product-price]');

    /* La cabecera del tema también es pegajosa, así que la barra no puede ir a
       top:0 — se montaría encima del menú. Se mide dónde acaba la cabecera en
       cada momento y la barra se coloca justo debajo. Si un día la cabecera
       cambia de alto o deja de ser pegajosa, esto sigue funcionando solo.

       El fallo que tuve aquí: `querySelector('a, b, c')` NO devuelve el primer
       selector que casa, devuelve el primer elemento del documento que casa
       cualquiera de ellos. En Impulse eso era #HeaderWrapper, que no está fijo
       y se va con el scroll, así que la medida salía siempre 0 y la barra se
       montaba encima del menú. Ahora se miran todos los candidatos y solo
       cuentan los que están de verdad fijos o pegajosos y pegados arriba; de
       esos se coge el que baja más. */
    var SELS = [
      '.site-header',
      '#SiteHeader',
      '.header-wrapper',
      '#HeaderWrapper',
      '.header-section',
      'header'
    ];
    var pedido = false;

    function bordeCabecera() {
      var abajo = 0;
      var vistos = [];
      for (var i = 0; i < SELS.length; i++) {
        var lista = document.querySelectorAll(SELS[i]);
        for (var j = 0; j < lista.length; j++) {
          var el = lista[j];
          if (vistos.indexOf(el) > -1) continue;
          vistos.push(el);
          var pos = '';
          try { pos = window.getComputedStyle(el).position; } catch (err) { pos = ''; }
          if (pos !== 'fixed' && pos !== 'sticky') continue;
          var r = el.getBoundingClientRect();
          /* pegada arriba y con alto real; el desplegable del megamenú no
             cuenta porque getBoundingClientRect no incluye a los hijos
             absolutos */
          if (r.height < 1 || r.top > 60 || r.bottom < 1) continue;
          if (r.bottom > abajo) abajo = r.bottom;
        }
      }
      /* tope de seguridad: si algún día una cabecera midiese medio viewport,
         mejor pegar la barra arriba que dejarla a mitad de pantalla */
      var tope = Math.round(window.innerHeight * 0.4);
      return Math.min(Math.round(abajo), tope);
    }

    function colocar() {
      pedido = false;
      if (window.innerWidth < 768) {
        barra.style.removeProperty('--jyg-sticky-top');
        return;
      }
      barra.style.setProperty('--jyg-sticky-top', Math.max(0, bordeCabecera()) + 'px');
    }

    function pedirColocar() {
      if (pedido) return;
      pedido = true;
      window.requestAnimationFrame(colocar);
    }

    window.addEventListener('scroll', pedirColocar, { passive: true });
    window.addEventListener('resize', pedirColocar);
    colocar();

    function refrescar() {
      var partes = Array.prototype.map.call(
        root.querySelectorAll('.jyg-variant-wrapper'),
        function (w) {
          if (getComputedStyle(w).display === 'none') return null;
          var c = w.querySelector('input[data-variant-input]:checked');
          return c ? c.value : null;
        }
      ).filter(Boolean);

      if (resumen) resumen.textContent = partes.join(' · ');
      if (precioEl && precioReal) precioEl.textContent = precioReal.textContent.trim();

      if (foto) {
        var elegido = root.querySelector('.jyg-variant-wrapper input[data-variant-input]:checked');
        var swatch = elegido && elegido.parentNode.querySelector('[data-jyg-swatch-img]');
        if (swatch && swatch.getAttribute('src')) foto.setAttribute('src', swatch.getAttribute('src'));
      }
    }

    /* El observador mira el botón real. Solo se enseña la barra cuando el
       botón ya ha quedado POR ENCIMA de la pantalla, es decir cuando el
       cliente ha pasado de largo. Si simplemente aún no ha llegado a él, la
       barra sobra: al aterrizar en la ficha nadie quiere un botón flotante. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var pasado = e.boundingClientRect.bottom < 0;
          if (pasado) barra.removeAttribute('hidden');
          else barra.setAttribute('hidden', '');
        });
      }, { threshold: 0 }).observe(ancla);
    }

    if (saltar) {
      saltar.addEventListener('click', function () {
        var destino = root.querySelector('.jyg-variant-wrapper') || ancla;
        destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-variant-input')) {
        setTimeout(refrescar, 30);
      }
    });

    refrescar();
  }

  function initAll(scope) {
    var ctx = scope || document;
    Array.prototype.forEach.call(ctx.querySelectorAll('.jyg-pdp'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
